export default __webpack_public_path__ + "static/media/klipartz.com.a630db57.png";